export default function() {
  const widgetName = 'cardWidgetAmpCountdown';
  const widgetOpts = cardWidgetAmpCountdownOpts;



  // CUSTOMIZED siteInfoBannerWidget.js code  -----------------------

  /*Site Info Banner Widget*/

  function customSiteInfoBanner(widgetData) {

    //Global variable for the widget function
    var widgetData = widgetData;
    var widgetContainer = $(`#${widgetName}`);
    var eventNameContentContainer = widgetContainer.find('#eventName');
    var eventDatesContentContainer = widgetContainer.find('#eventDates');
    var numberOfDays = 0;
    var previouslyViewedDate = true;
    var customConnector = null;
    var eventLength = null;
    var afterMessage = '';
    var siteInfoBannerLoaded = function () { };
    var countdownTextPrefix = '{#days} Days';


    function getNumberOfDaysRemaining(startDate) {
      var eventStartDate = new Date(startDate).getTime();
      var now = new Date().getTime();   
      var distance = eventStartDate - now;    
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        
      if (distance < 0) {
        return days + 1;
      } else {
        if (days === 0) {
          return 1;
        } else {
          return days;
        }
      }

    }


    if(widgetData.ShowAfterEventMessage == true){
      afterMessage = widgetData.AfterEventMessage;
    }


    var m = 0;
    eventLength = widgetData.EventLength;
    numberOfDays = getNumberOfDaysRemaining(widgetData.StartDate);

    if(numberOfDays <=0){
      m = numberOfDays + eventLength;
    }

    var i = numberOfDays + 50;
      if (numberOfDays > 0) {
      var until = 'Until ';

      if(customConnector!=null){
        until = customConnector;
      }


    eventDatesContentContainer.text(widgetData.DateString)
    if (previouslyViewedDate == false) {
      setInterval(function () {
        if (i >= numberOfDays) {
          if (i == 1) {
              eventNameContentContainer.html('<span class="countdownDays">' + i + ' <span class="dayWord">day</span></span> ' + until + widgetData.EventName);
              i--;
          }
          else {
              eventNameContentContainer.html('<span class="countdownDays">' + i + ' <span class="dayWord">days</span></span> ' + until + widgetData.EventName);
              i--;
          }


        }
      }, 50);
    } else {
      if (numberOfDays == 1) {
        eventNameContentContainer.html('<span class="countdownDays">' + numberOfDays + ' <span class="dayWord">day</span></span> '+until + widgetData.EventName);
      } else {
        eventNameContentContainer.html('<span class="countdownDays">' + numberOfDays + ' <span class="dayWord">days</span></span> '+until + widgetData.EventName);
      }

    }

    } else if (m < 0) {
        // if (widgetData.EventName != null) {
        //     eventDatesContentContainer.text(widgetData.EventName);
        // }

      eventNameContentContainer.html('<span class="countdownDays">'+afterMessage+'</span>');
      if(afterMessage == ''){
        $('#widgetBanner').addClass('noThankYouMessage');  // this is NOT the preferred method (preferred method is on following line) - this is to support clients that rely on this class
        $('body').addClass('siteInfoBannerWidgetNoThankYouMessage');  // preferred method allows a class to be added even when the widget is not added to the banner
      }
      $('#widgetBanner').addClass('datePast');  // this is NOT the preferred method (preferred method is on following line) - this is to support clients that rely on this class
      $('body').addClass('siteInfoBannerWidgetDateIsPast'); // preferred method allows a class to be added even when the widget is not added to the banner

      $('.countdown-wrapper').hide();
    }

    else {
      $(`#${widgetName}`).css('display', 'block');
      eventDatesContentContainer.text(widgetData.DateString);
      eventNameContentContainer.css('display', 'none');
      $('#widgetBanner').addClass('eventHappening'); // this is NOT the preferred method (preferred method is on following line) - this is to support clients that rely on this class
      $('body').addClass('siteInfoBannerWidgetEventHappening'); // preferred method allows a class to be added even when the widget is not added to the banner
    }

    siteInfoBannerLoaded(widgetData);
    var infoBannerCountdownContent = $('.countdownDays').html();
    var infoBannerDatesContent = $('#eventDates').html();
    if(infoBannerCountdownContent == '' && infoBannerDatesContent == ''){
      $('body').addClass('siteInfoBannerOff');
    } else {
      $('body').addClass('siteInfoBannerOn');
    }
    
    widgetContainer.show();

  }

  // ---------------------------------------
  // ---------------------------------------




  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {

      if (data.items.length > 0) {
        const w = $(`#${widgetName}`);
        const t = data.items[0].Title;
        const d = data.items[0].Description;
        const h = `
          <div id="eventDates"></div>
          <div id="eventName">
            <span class="countdownDays"> 
              <span class="dayWord"></span>
            </span>             
          </div>
        `; 
        w.html(h);
        // w.show();

        const descJSON = JSON.parse(data.items[0].Description);
        customSiteInfoBanner(descJSON);

      } else {
        $('.countdown-wrapper').hide();
      }

    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'Buy Tickets'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}